import { Box } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "./export.module.scss";
import i18next from "i18next";
import PageTitle from "../../components/pageTitle/PageTitle";
import SubTable from "../../components/subTable/SubTable";
import VehicleExportForm from "./components/VehicleExportForm";
import TextBoxCompOne from "../../components/textBoxCompOne/TextBoxCompOne";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { useApiErrorModalContext } from "../../errorHandling/ApiErrorModalContext";
import { getVehicleList } from "../../services/APIService";
import _ from "lodash";
export function TooltipWrapper(val, styleval) {
  if (val?.length <= 21) {
    return <Box className={styleval}>{val}</Box>;
  } else
    return (
      <Tooltip
        disableInteractive
        title={val}
        PopperProps={{
          sx: {
            "& .MuiTooltip-tooltip": {
              width: "180px",
              padding: "2px 0px",
              textAlign: "center",
              fontSize: "12px",
              color: "common.white",
              backgroundColor: "#808080",
              borderRadius: "5px",
            },
          },
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -5],
              },
            },
          ],
        }}
      >
        <Box className={styleval}>{`${String(val).slice(0, 10)}.....`}</Box>
      </Tooltip>
    );
}
const VehicleExport = () => {
  const [tableColumnData, setTableColumnData] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const history = useNavigate();
  const { setApiErrorModalState } = useApiErrorModalContext();
  const [vehicleList, setVehicleList] = useState([]);

  const defaultVehicleListParams = {
    IsDesc: false,
    PageNumber: 1,
    PageSize: 5,
  };

  const fetchVehicleList = useCallback(() => {
    getVehicleList(defaultVehicleListParams)
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          let vehicleList = _.get(response, "vehicleDtoList", []);

          setVehicleList(vehicleList);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchVehicleList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const tableHeaderColumns = [
      {
        field: "licensePlateNo",
        headerName: i18next.t("License, VIN"),
        flex: 2,
        sortable: false,
        renderCell: (params) => (
          <TextBoxCompOne
            headerText={params.row?.licensePlateNo}
            subText={`VIN no.: ${params.row?.vin}`}
            headerTextStyle={styles.headerText}
            subTextStyle={styles.vehicleSubText}
          />
        ),
      },
      {
        field: "dealerName",
        headerName: i18next.t("Dealer"),
        flex: 1.5,
        sortable: false,
        renderCell: (params) =>
          TooltipWrapper(params.row?.dealerName, styles.normalTextWrapper),
      },

      {
        field: "isActive",
        sortable: false,

        headerName: (
          <Box className={styles.twoLineColumn}>
            {` ${i18next.t("Active")} / ${i18next.t("Inactive")}`}
          </Box>
        ),
        flex: 0.8,
        renderCell: (params) => (
          <Box className={styles.statusWraper}>
            {params.row?.isActive ? i18next.t("Active") : i18next.t("Inactive")}
          </Box>
        ),
      },
    ];
    setTableHeader(tableHeaderColumns);

    setTableColumnData(vehicleList);
  }, [vehicleList]);

  return (
    <Box
      className={`${styles.dealerExportWrapper}`}
      data-testid="VehicleExport"
    >
      <PageTitle
        title={`${i18next.t("Export vehicle data")}`}
        data-testid="pagetitle"
      />
      <Box className={`twoSectionPageWrapper`}>
        <Box className={`${styles.leftContentWrapper} leftSideWrapper`}>
          <VehicleExportForm />
        </Box>
        <Box className={`${styles.rightContentWrapper} rightSideWrapper`}>
          <Box className={styles.vehicleSubTable}>
            <SubTable
              tableHeader={tableHeader}
              tableColumnData={tableColumnData}
              title={i18next.t("Recent vehicles")}
              handleBtnAction={() => history("/vehicles")}
            />

            <Box className={styles.tableAction}></Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default VehicleExport;
